import { NavLink } from 'react-router-dom';
import './AdminNav.css';

function AdminNav() {
  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `admin-nav-link ${isActive ? 'admin-nav-link-active' : ''}`;

  return (
    <nav className="admin-nav">
      <NavLink to="/admin" end className={navLinkClass}>Dashboard</NavLink>
      <NavLink to="/admin/users" className={navLinkClass}>User Management</NavLink>
      <NavLink to="/admin/api-keys" className={navLinkClass}>API Keys</NavLink>
      <NavLink to="/admin/payment-events" className={navLinkClass}>Payment Events</NavLink>
    </nav>
  );
}

export default AdminNav;
